import { Box, Typography } from "@material-ui/core";
import moment from "moment";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import history from "../../history";
import { auth as authPath } from "../../routes/auth";
import * as actions from "../Carts/actions";
import FSLoader from "../Loaders/FSLoader";
import { welcomeLogo as logo } from "../logo";
import useTranslations from "../Translations/useTranslations";
import Button from "../ui/Buttons";
import theme from "../ui/theme";
import apis from "./../Clients/api";
import { auth } from "./api";
import { types } from "./reducer";

function AuthForm() {
  const trl = useTranslations();
  const [credentials, setCredentials] = useState({});
  const [is_logging, setIsLogging] = useState(false);
  const [error, setError] = useState();
  const dispatch = useDispatch();

  const isFetching = useSelector((state) => state.trl.isFetching);

  const _onChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const login = (credentials) => {
    setIsLogging(true);
    dispatch({
      type: actions.UPDATE_CART_LOADING_STATUS,
      payload: { isLoad: false },
    });
    auth.login(credentials).then(async (data) => {
      setIsLogging(false);

      if (data.success === false) {
        dispatch({ type: types.LOGIN_FAILED });
        setError(data.status_msg);
        return;
      }

      dispatch({ type: types.LOGIN_SUCCESS, payload: data.payload });

      const carts = data.payload?.carts || [];

      if (carts.length >= 0) {
        handleCarts(carts).finally(() => {
          dispatch({
            type: actions.UPDATE_CART_LOADING_STATUS,
            payload: { isLoad: true },
          });
        });
      }

      history.replace("/");
    });
  };

  const handleCarts = async (carts) => {
    const dispatchCart = (cart, client) => {
      dispatch({
        type: actions.CREATE_CART,
        payload: {
          client: client?.payload || null,
          id: Number(cart._id),
          creator: cart.codcli,
          products: cart.cart?.products || {},
          packs: cart.cart?.packs || [],
          created_at: cart.cart?.created_at
            ? moment(cart.cart.created_at)
            : moment(),
          codcli: cart.codcli,
        },
      });
    };

    const uniqueCodcli = [...new Set(carts.map((c) => c.codcli))];

    const clientsMap = {};

    await Promise.all(
      uniqueCodcli.map(async (codcli) => {
        clientsMap[codcli] = await apis.fetchClient(codcli);
      }),
    );

    carts.forEach((cart) => {
      dispatchCart(cart, clientsMap[cart.codcli] || null);
    });
  };

  const styles = {
    inputContainer: {
      ...theme.neumorphicOutset,
      borderRadius: 100,
      padding: theme.spacing(0.75),
    },
    input: {
      width: "100%",
      border: "none",
      backgroundColor: "transparent",
      outline: "none",
    },
  };

  return (
    <React.Fragment>
      {isFetching ? (
        <FSLoader />
      ) : (
        <React.Fragment>
          <Box display="flex" justifyContent="center">
            <img className="img-fluid" src={logo} alt="Welcome Logo" />
          </Box>

          <Box mt={2}>
            <Typography variant="h6" align="center">
              {trl.message("LoginPage.title")}
            </Typography>
          </Box>

          <div className="my-5">
            <div className="mt-3" style={styles.inputContainer}>
              <input
                style={styles.input}
                onChange={(e) => _onChange(e)}
                name="email"
                type="text"
                placeholder={trl.message("LoginPage.loginInputPlaceholder")}
              />
            </div>

            <div className="mt-3" style={styles.inputContainer}>
              <input
                style={styles.input}
                onChange={(e) => _onChange(e)}
                name="password"
                type="password"
                placeholder={trl.message("LoginPage.passwordInputPlaceholder")}
              />
            </div>
          </div>

          <Button
            block
            onClick={() => login(credentials)}
            loading={is_logging}
            label={trl.message("LoginPage.loginAction")}
          />
          <Box>
            <Link to={authPath.FORGET.path}>
              {trl.message("LoginPage.showForgetInstructionsLabel")}
            </Link>
          </Box>
        </React.Fragment>
      )}
      {error && (
        <div
          style={{
            padding: theme.spacing(1),
            marginTop: theme.spacing(1),
            backgroundColor: "#f4ecec",
          }}
        >
          {trl.message("LoginPage.invalidCredentialsError")}
        </div>
      )}
      {}
    </React.Fragment>
  );
}

export default AuthForm;
